<div class="mobile-no-padding">
  <h3 class="chart-heading">{{ "Monthly rainfall sum" | translate}} {{rainYearNum}}</h3>
  <div class="card max-w-1300 card--desktop-only">
    <div class="card-body">
      <div class="chart not-mobile" #chartElement id="{{chartID}}" style="height:400px;"></div>
      <div class="well mobile-only"> {{'Please rotate your phone to see the chart' | translate}}</div>
    </div>
  </div>
</div>